export const errorCodeToken = '{ERROR_CODE}';
export const ErrorTemplate = {
    error: '<br><br>Error Code: {ERROR_CODE}'
};
